export default __webpack_public_path__ + "3135c90c6056123ad199211de465e3fe.svg";